export default {
  share: {
    planCard: {
      viewPriceTable: '查看价格表',
      facilityDetails: '设施详情'
    },
    priceTableDialog: {
      title: '价格表',
      dateFormat: '{{month}}月{{day}}日{{weekday}}',
      weekdays: {
        0: '周日',
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六'
      }
    },
    common: {
      account: '账户',
      myPage: '我的主页',
      booking: '订单记录',
      logout: '退出登录',
      save: '保存',
      colon: '：',
      multiply: '×',
      next: '下一步',
      return: '返回',
      toPay: '前往付款',
      update: '更新',
      search: '搜索',
      delete: '删除',
      space: ' ',
      comma: ',',
      titleSeparator: ' · ',
      add: '加购',
      change: '变更',
      confirm: '确认',
      cancel: '取消',
      searchPlaceholder: '搜索...',
      tilde: '~',
      showMore: '更多',
      notification: '通知',
      withParentheses: '{{value1}}（{{value2}}）',
      withDashSeparated: '{{val1}} - {{val2}}',
      selectTime: '请选择时间'
    },
    price: {
      primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
      prefix: '<currency>{{currency}}</currency><amount>{{amount}}</amount>',
      suffix: '<amount>{{amount}}</amount><currency>{{currency}}</currency>',
      jpyWord: 'JPY',
      cnyWord: '元',
      jpySymbol: '¥'
    },
    footer: {
      terms: '使用条款',
      cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
      copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
    },
    validation: {
      required: '{{field}}为必填项',
      invalid: '请输入有效的{{field}}',
      password: '请输入至少8个字符，包含大写字母、小写字母、符号和数字',
      imageType: '请选择图片文件',
      fileSize: '请选择小于{{size}}MB的文件',
      range: '请输入{{min}}到{{max}}之间的值',
      requiredSelect: '请选择{{field}}选项',
      nameInvalid: '{{field}}包含非法字符',
      emailNotMatch: '邮箱地址不一致',
      emailAlreadyRegistered: '该邮箱地址已注册，请先通过登录按钮进行登录。',
      ticketExpired: '购买时间不能晚于活动开始时间。'
    },
    firebase: {
      'auth/wrong-password': '帐户名或密码有误。',
      'auth/user-not-found': '帐户名或密码有误。',
      'auth/email-already-in-use': '该邮箱已被注册。',
      'auth/too-many-requests': '登录失败超过有限次数，烦请重设密码或稍后再试。'
    },
    apiErrors: {
      baseError: '检测到有错误发生。',
      clientError: 'API 请求存在错误。',
      serverError: '服务器无法完成该请求。',
      connectionError: '与服务器的连接失败。请检查网络设置后重试。',
      requestError: 'API 请求存在错误。',
      ARSError: {
        AFFILIATE_ID_REQUIRED:
          '操作失败，请回到原会员专属首页后再次进入商品页重新尝试。',
        BOOKING_NOT_ENOUGH_ALLOTMENT:
          '非常抱歉，由于所选日期/时间之库存数量不足，烦请选择其他日期/时间预订。',
        BOOKING_NO_AVAILABILITY:
          '非常抱歉，由于所选日期/时间之库存数量不足，烦请选择其他日期/时间预订。',
        PERMISSION_DENIED: '非常抱歉，您无权访问该资源。',
        NOT_FOUND: '未找到资源。',
        BOOKING_ALREADY_ISSUED: '恕无法取消已兑换或使用的订单。',
        BOOKING_RESERVATION_OVERLIMIT: '预订数量已超出上限。',
        BOOKING_RATE_LIMITED:
          '当前访问量较大。\n对于给您带来的不便，我们深表歉意。\n烦请稍后通过下方的＜前往付款＞按钮再次继续操作。'
      },
      lottery: {
        LOTTERY_ALREADY_APPLIED:
          '此票券每人限购一次。您已完成申请，无法再次购买。'
      }
    },
    header: {
      openMenu: '打开菜单',
      closeMenu: '关闭菜单'
    },
    login: {
      title: '登录／注册',
      caption: '请选择登录、注册会员的方式。',
      appleLogin: 'Apple',
      googleLogin: 'Google',
      email: '邮箱地址',
      emailConfirm: '邮箱地址（确认）',
      password: '密码',
      button: '登录',
      forgotPassword: '忘记密码？',
      newAccount: '注册',
      signInAgree:
        '※可使用第三方帐户轻松登录、注册会员。\n ※当您使用邮箱或第三方帐户登录时，将视同您已同意相关 <TermsLink>{{terms}}</TermsLink> 与 <PrivacyLink>{{privacy}}</PrivacyLink> 。',
      otpErrorMsg: '验证码输入错误，请重新输入。'
    },
    cart: {
      button: '购物车',
      empty: '购物车为空',
      addToCart: '添加到购物车',
      totalCount: '共 {{count}} 个商品',
      totalAmount: '合计',
      unavailable: '无法购买',
      deleteConfirm: '确定要删除「{{activityName}}」吗？',
      availabilityConfirmTitle: '确认购物车内容',
      availabilityConfirmContent:
        '购物车中包含已过销售期或已售罄的商品。是否删除这些商品并继续下单？',
      availabilityConfirmProceed: '删除并继续',
      availabilityConfirmBack: '返回购物车'
    },
    payment: {
      ticket: '门票',
      plan: '套餐',
      dateTime: '日期时间',
      validityPeriod: '有效期',
      option: '附加商品',
      discount: '优惠',
      total: '合计（含税）',
      details: '详情',
      submit: '去下单',
      lotterySubmit: '申请抽选',
      lotteryBeforeOpen: '抽选未开始',
      lotteryClosed: '抽选已结束',
      numberOfPeople: '人数',
      totalWithTax: '合计 (含税)',
      viewPlan: '查看套餐',
      warn: '不允许只购买{{unitName}}',
      optionRequiredTag: '必选',
      optionRequiredTip: '必须选择附加商品'
    },
    password: {
      changePassword: '更改密码',
      resetPassword: '重设密码',
      sendResetEmail: '发送密码重设邮件',
      sendResetEmailSuccess:
        '已将密码重设链接发送至{{email}}，烦请确认并重新设定密码。',
      oldPassword: '原密码',
      newPassword: '新密码',
      changePasswordSuccess: '密码已成功变更。'
    },
    emailVerification: {
      title: '验证邮件已发送',
      description: '验证邮件已发送至{{email}}。',
      instruction: '请输入邮件中的验证码完成注册',
      resend: '重新发送',
      verify: '登录'
    },
    date: {
      sunday: '星期日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六'
    },
    profile: {
      title: '个人信息',
      firstName: '名',
      lastName: '姓',
      email: '邮箱',
      confirmEmail: '邮箱（确认）',
      password: '密码',
      gender: '性别',
      birthday: '出生日期',
      country: '国家和地区',
      prefecture: '省份',
      genderOptions: {
        male: '男性',
        female: '女性',
        other: '其他'
      },
      updateProfileSuccess: '个人信息更新成功',
      updateProfileFailed: '个人信息更新失败, 请稍后重试',
      creditCardManagement: '信用卡管理',
      creditCardManagementGetErrMsg: '获取信用卡信息失败。'
    },
    weeks: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    },
    empty: {
      message: '没有内容'
    },
    notFound: {
      subtitle: '此页面暂不可用',
      returnHome: '返回首页'
    },
    notFoundAuth: {
      subtitle: '此页面暂不可用'
    },
    details: {
      title: '查看详情'
    },
    orderConfirm: {
      title: '下单前确认事项',
      agree: '同意'
    },
    invoice: {
      title: '开具发票',
      info: '发票信息',
      name: '发票抬头',
      remarks: '备注信息',
      cancelFee: '取消手续费',
      cancelFeeAmount: '手续费金额',
      email: '接收发票的电子邮箱',
      check:
        '每笔订单原则上仅受理申请开具发票一次，如需再次开具发票，第二次起开具的发票皆将标注"补发"，敬请留意。',
      description: '品名／用途',
      content: '发票内容',
      confirm: '确认提交',
      success: '发票开具成功，请查收邮箱：{{email}}',
      price: '支付金额',
      refundAmount: '退款金额'
    }
  },
  faq: {
    title: '常见问题',
    bookingProcess: {
      title: '订购流程',
      q1: '如何确认是否已完成订购呢？',
      a1: `当您预订完成，系统将发送订单确认信至您所登录的电子邮箱，烦请查收信内所附订单信息及凭证。如收到附有“使用电子票”链接的信件，可点击后直接使用。
  此外，您也可以点击信内的“订单详情”以确认您的订单信息。`,
      q2: '没有收到订单确认邮件，该怎么办呢？',
      a2: `当您订购"订购即时确认"的商品，订单将于约5分钟内被自动确认并发送订单确认信至您所登录的电子邮箱，若超过时间仍未收到订单确认信，烦请检查您的垃圾信件夹内是否有来自"@linktivity.co.jp"的信件。`,
      q3: '可以重新发行凭证吗？',
      a3: `可以，请按照以下步骤重新获取凭证：

1.登录您的账号后，点击右上角「我的主页」→「预订信息」。
2.在对应订单中点击「查看详情」。
3.在「凭证信息」栏确认凭证内容，并可点击「发送凭证」重新发送至您注册的电子邮箱。`
    },
    payments: {
      title: '支付',
      q1: '支付时出现了订购失败的讯息，该怎么办呢？',
      a1: `若发生此情形请先不要马上重新订购，请先于右上角的"帐户"点击"订单信息"，查看订单一览中是否有该订单的纪录，或烦请查收是否有收到订单确认信。若皆未能找到订单纪录，则烦请稍待约5分钟后再重新订购。`,
      q2: '可以给我收据吗？',
      a2: `抱歉目前无提供线上发行收据的服务，如需收据，烦请来信至客服邮箱<helpcenter@linktivity.co.jp>，并请注明您的订单编号、收据抬头、款项名称、金额等信息。`,
      q3: '可使用哪些支付方式呢？',
      a3: `您可使用信用卡进行支付（部分商品可使用Alipay、WeChat Pay支付）。恕无法使用便利店支付或现金支付。`,
      q4: '什么是3D验证？',
      a4: `3D验证为一种身份验证服务，可防止信用卡被盗刷等非法使用，提高持卡人在进行信用卡线上消费时的安全性。
  使用支援3D验证的信用卡进行支付时，会要求持卡人输入一次性密码进行身份验证（验证方式依信用卡公司而异）。`,
      q5: '该如何申请3D验证？ 我不知道自己的信用卡是否支援3D验证。',
      a5: `3D验证可在刷卡前向信用卡公司申请完成注册手续。
  如不清楚自己的信用卡是否支援3D验证，请洽询卡片背面的信用卡公司客服专线。 `,
      q6: `我不知道自己的3D验证密码。我没收到3D验证一次性密码。`,
      a6: `进行3D验证时所需的密码为事先向信用卡公司申请3D验证时所设定的密码，或是一次性密码。
  如未收到一次性密码，请检查您的垃圾邮件。
  如不清楚密码或是未收到一次性密码，请洽询卡片背面的信用卡公司客服专线。 `,
      q7: `只能使用已注册3D验证的信用卡吗？`,
      a7: `因近期信用卡盗刷事件剧增，日本经济产业省宣布预计于2025年3月下旬全面履行电子商务本人认证（EMV 3-D验证）义务化，恕本服务仅供已注册3D验证的信用卡可使用，敬请谅解。
  此外，于2023年3月发布的《信用卡安全指南【4.0版】》指出，将针对电子商务业者、信用卡公司（发卡公司、加盟店管理公司）及代理支付业者，全面履行“本人认证义务化及相关应对服务”。为符合上述准则，在新的预订平台上必须使用提供3D验证的支付系统。`,
      q8: `我可以使用借记卡吗？`,
      a8: `您可以使用借记卡。`,
      q9: '3D验证及额度均没问题、在其他网站上也可正常使用的信用卡，为什么会一直出现错误，无法支付？',
      a9: `如您的信用卡没有问题却无法支付，代表信用卡公司的支付审批系统可能发现有未经授权的使用纪录，并可能已取消支付以保护您的信用卡。
  此情况与人为判断不同，电脑会预测各种因素并根据该情况做出判断，而造成在特定时间内无法支付的可能性。
  如遇上述问题，可改尝试下述方法。
  ・使用不同的信用卡支付。
  ・过一段时间后再度尝试使用该信用卡支付。
  ・联络您的信用卡公司，说明您想订购的票券名称和情况，要求信用卡公司订正诈欺侦测和支付审批系统错误。`,
      q10: '我已收到信用卡公司的刷卡通知，但”我的帐户“中没有该订单信息，也没收到订购完成的电子邮件。',
      a10: `此情形可能为以下问题。
  ・电子邮箱输入错误（拼字错误等）。
  ・订购时输入的电子邮箱与平时使用的的电子邮箱不同。
  ・支付和订购未完成（信用卡额度没问题，但因某些错误导致支付和订购未完成）
  如您有订购时输入的某个电子邮箱印象，请尝试使用该邮箱登入“我的帐户”。
  如仍无法成功登入，请将下述信息与问题发送至LINKTIVITY客服中心<helpcenter@linktivity.co.jp>  ，由我们帮您查询您的支付和订购记录。
  -订购人姓名（英文拼音）：
  -活动参加日：
  -支付日期和时间（例：3/2 19:00）：
  -支付信用卡末3码 ：
  -支付信用卡有效期限：
  -总金额：
  -订购时可能输入的电子邮箱：`
    },
    changesAndCancellations: {
      title: '变更与取消',
      q1: '不小心订错了，该怎么取消呢？',
      a1: `若您订购的是可以取消的商品，请登入帐号后，依以下步骤取消：
  1.请于右上角的"帐户"点击"订单信息"。
  2.请于该订单点击"查看详情"。
  3.请于"取消信息"栏确认取消政策，并点击"开始取消"，确认取消费用后请点击"取消"即可取消订单。`,
      q2: '取消订单后何时可退款呢？',
      a2: `取消订单后，退款时间依您的信用卡公司而异，如欲确认具体的退款时间，烦请向您的信用卡公司咨询。`,
      q3: '可以变更订单吗？',
      a3: `烦请先取消原本的订单，再重新订购。由于是否可取消以及取消政策依商品而异，请先于商品页下方的取消政策栏确认。`
    },
    accounts: {
      title: '帐户',
      q1: '该如何注册帐号呢？',
      a1: `您可于网站右上角的"登入"进行注册，或于商品页上订购时亦可注册。由于近日常发生注册帐号时输入了错误邮箱的情形，注册帐号时烦请确认是否有输入正确的电子邮箱。
  此外，您亦可通过Apple或Google等帐号登入使用本服务。`,
      q2: '该如何登入呢？',
      a2: `请于订购网站上的右上角点击"登入"即可开始登入您的帐户。`,
      q3: '忘记密码了该怎么办呢？',
      a3: `请于登入页面点击"忘记密码？"，依照页面指示的步骤重新设定密码。`
    },
    environment: {
      title: '网络环境',
      q1: '使用本网站时该使用什么浏览器？',
      a1: `推荐使用以下浏览器：
  ・Firefox （最新版）
  ・Safari （最新版）
  ・Google Chrome （最新版）`,
      q2: '订单确认信是使用什么域名的邮箱发送的呢？',
      a2: `本服务的邮箱域名为"@linktivity.co.jp"，如有为预防垃圾邮件而设置电子邮件的网域限制，请于订购前事先将"@linktivity.co.jp"加入白名单。`
    },
    ticket: {
      title: '使用电子票',
      q1: '什么是一次性密码验证？',
      a1: `当您的链接环境（装置或浏览器等）发生变化时，为防止电子票遭第三者非法使用，本预订系统将会发送一次性密码（仅限一次有效的密码）供您验证。
  
  于不同的使用环境首次打开电子票时，系统将会发送一次性密码以供验证。
  为了确保使用当日可顺利使用电子票，建议您可先于活动当日使用的行动装置或浏览器上开启电子票，查阅内容。
  
  例：
  第一次开启电子票：A先生在自己的智能手机上开启电子票时，不需进行一次性密码验证。
  第二次开启电子票：A先生在家人的智能手机上开启电子票时，因与第一次开启电子票的行动装置不同，将会出现要求完成一次性密码验证画面。须完成验证。
  此时输入的电子邮箱将会被登录、固定于系统上。若第三次再以不同的行动装置开启电子票时，一次性密码将会发送至该邮箱。建议活动当日可先于邮箱内确认是否可收到一次性密码。`,
      q2: '我突然收到“您的链接环境已变化”信息。该如何出示电子票？',
      a2: `当您的链接环境发生变化（使用与第一次开启电子票的不同装置或浏览器开启电子票）时，须进行一次性密码验证。
  若出现上述讯息时，请先输入您欲收到一次性密码的电子邮箱。 ※建议输入可于活动当日现场查看一次性密码的电子邮箱，并确认该邮箱是否可收到一次性密码。
  当您收到邮件后，请输入正文内的一次性密码。如密码无误即验证完成，可显示您的电子票。`,
      q3: '我没收到一次性密码的电子邮件。',
      a3: `若超过时间仍未收到一次性密码邮件，烦请检查是否有在垃圾信件夹内。若您有限制网域，烦请将“@linktivity.co.jp”加至您的网域许可权。若已尝试过上述方法仍未收到电子邮件，可能是您输入的电子邮箱有误。烦请重新正确输入电子邮箱，或尝试输入其他的有效电子邮箱。`,
      q4: '我可以更改一次性密码的收件邮箱吗？',
      a4: `恕无法更改一次性密码的收件邮箱。一次性密码一经验证完成，之后的一次性密码皆会发送至您登录的电子邮箱内。建议您登录可于活动当日的行动装置（当日携带的智能手机等）上查看电子票的电子邮箱。`,
      q5: '我没购买任何商品却一直收到一次性密码的验证信，这是否为遭盗刷等非法使用？',
      a5: `若您一直收到一次性密码的验证信，可能为以下原因：
  ・您将电子票（凭证）转发给其他同行游客：
  若您的同行游客在您开启电子票、并完成一次性密码验证后开启电子票时，因使用的装置不同，系统将会向您发送一次性密码验证信。
  此时，因您的一次性密码收件邮箱（验证一次性密码时登录的邮箱）已被固定，每当您的同行游客连接电子票时，系统将会依该次数发送一次性密码验证信。
  ・非法使用：若您未将电子票转发给他人，则可能遭人盗用。请您深思熟虑，如有需要烦请重新订购。`,
      q6: '我收到由不明邮箱发送的一次性密码。',
      a6: `若您收到来自不明邮箱发送的一次性密码，可能为以下原因：
  ・您将电子票（凭证）转发给其他同行游客：
  若您在您的同行游客开启电子票、并完成一次性密码验证后开启电子票时，因使用的装置不同，系统将会向您发送一次性密码验证信。此时，一次性密码的收件邮箱已被固定为该同行游客的电子邮箱（验证一次性密码时登录的邮箱），系统将自动发送密码验证信至该邮箱。若遇此种情况，建议您可先询问您的同行游客。
  ・非法使用：若您未将电子票转发给他人，则可能遭人盗用。请您深思熟虑，如有需要烦请重新订购。`
    }
  },
  privacy: {
    lastUpdated: '最后更新时间：2022年3月18日',
    companyName: 'Linktivity Inc.',
    title: '隐私政策',
    personalInfoProtectionPolicy: '个人信息保护政策',
    personalInfoProtectionDescription:
      'Linktivity Inc.(以下称"公司")通过预订网站LINKTIVITY等收集用户的个人信息。公司认为保护用户个人信息以使用户能够安心便利地进行预订是极其重要的，公司遵守以下规定进行个人信息处理。',
    customerDataManager: '用户数据管理员',
    companyAddress: '日本东京都千代田区内幸町2-1-6 日比谷公园前19楼',
    acquisition: '采集',
    acquisitionDescription:
      '公司仅在法律要求时获得用户同意后，为达到规定的使用目的而采集最少必要的个人信息。',
    usage: '使用',
    usageDescription: '公司仅将从用户处采集的个人信息用于达到规定的使用目的。',
    storage: '存储和保留',
    storageDescription:
      '公司谨慎关注系统安全，防止从用户处采集的个人信息向外部泄露，进行个人信息的存储和保留。',
    destruction: '销毁和删除',
    destructionDescription:
      '公司对不再需要使用的个人数据从不再需要的时点起毫不迟延地进行销毁。',
    customerInquiry: '对用户查询的响应',
    customerInquiryDescription:
      '公司根据相关法律法规对用户关于持有个人数据的使用目的通知请求、公开请求、更正/增加/删除请求、使用中止/删除请求以及第三方提供中止请求进行对应。',
    safetyMeasures: '安全管理措施',
    safetyMeasuresDescription:
      '公司通过教育确保所有与LINKTIVITY服务相关的员工理解个人信息的重要性，并采取必要且适当的措施进行个人信息保护。',
    tableOfContents: '目录',
    policy1: {
      title: '公司采集的个人信息及使用目的',
      description:
        '公司为以下规定的使用目的采集和使用用户的地址、姓名、出生日期、联系方式、电子邮件地址、护照号码等个人信息。公司不在未获用户同意的情况下采集敏感个人信息。在采集用户个人信息时，如个人信息的使用目的未公开，公司应向用户通知或公开该采集的个人信息的使用目的。公司不在未获父母同意的情况下采集13岁以下儿童的个人信息。在提供13岁以下儿童的个人信息时，公司将其视为已获得父母同意，但如明确得知未获同意，公司除了与父母联系及相关目的外，不使用该个人信息。',
      serviceUsage: {
        title: 'LINKTIVITY服务使用(会员注册等)',
        description: '为使用LINKTIVITY服务，用户个人信息在公司内部共享。',
        legalBasis: '为提供用户要求的服务和功能而必需。'
      },
      ticketPurchase: {
        title: '车票购买申请',
        infoItems:
          '公司在处理来自产品提供商的车票购买申请时，采集用户的姓名、支付信息、护照号码以及用户的健康状况相关信息，包括健康状态和病史。',
        purpose:
          '公司采集和使用用户个人信息以验证来自产品提供商的车票购买资格并处理车票及相关费用的支付。为实现这一目的，公司可向产品提供商、运输公司、支付处理器和其他服务提供商(包括海外提供商)提供用户个人信息。',
        legalBasis: '为提供用户要求的服务和功能而必需。'
      },
      newsletter: {
        title: '发送新闻通讯(电子邮件杂志等)及用户通信',
        legalBasis: '基于用户同意采集。'
      },
      advertising: {
        title: '通过社交媒体和广告分发平台进行的广告',
        legalBasis: '基于用户同意采集。'
      },
      survey: {
        title: '问卷调查参与请求',
        legalBasis: '基于用户同意采集，用于改进预订网站、产品和服务。'
      },
      analysis: {
        title: '用户信息分析和管理',
        legalBasis:
          '为通过改进预订网站、产品和服务来追求和保护用户的正当利益而必需。'
      },
      fraudDetection: {
        title: '信用卡等欺诈使用检测',
        legalBasis: '为确保用户信用卡的安全并追求用户的正当利益而必需。'
      }
    },
    policy2: {
      title: '个人数据的第三方提供',
      description: '除以下情况外，公司不向第三方提供从用户处采集的个人数据。',
      case1:
        '当用户通过本隐私政策或其他方式事先同意向第三方(包括产品提供商、海外旅行社、社交媒体提供商、广告分发服务公司等)提供个人数据时。',
      case2: '当在达到规定使用目的所必需的范围内将个人数据处理外包给第三方时。',
      case3: '当法律要求提供时。',
      case4: '当为保护人类生命、身体或财产而必需，且难以获得用户同意时。',
      case5:
        '当为改进公共卫生或促进儿童健全发展而特别必需，且难以获得用户同意时。',
      case6:
        '当政府或地方政府为实施法律规定的事务而需要合作，且获得用户同意可能会阻碍该事务的执行时。'
    },

    policy3: {
      title: '个人数据处理的委托',
      description:
        '当公司在达到规定使用目的所必需的范围内将用户个人数据处理委托给第三方时，公司对受委托的机构进行必要且适当的监督。如受委托的机构进一步委托给其他机构，公司直接或间接监督受委托的机构是否对再委托机构进行了必要且适当的监督。再委托机构的进一步委托情况也应如此。'
    },
    policy4: {
      title: 'Cookie信息等采集',
      cookie: {
        title: 'Cookie',
        description1:
          'Cookie是存储在用户硬盘上包含有关用户信息的数据文件。公司不使用Cookie来识别个人。Cookie是会话Cookie，当用户关闭浏览器时不会被保留。Cookie用于改进用户服务、自定义网站、测量广告效果等目的。',
        description2:
          '公司将Cookie作为统计数据进行分析，以识别用户的兴趣和关注点并加以利用。Cookie也用于防止未授权访问。',
        description3:
          '用户可根据偏好禁用Cookie，但这样做会导致用户无法在LINKTIVITY进行预订。'
      },
      logFile: {
        title: '日志文件',
        description1:
          '公司自动采集某些信息并将其保存到日志文件。这些特定信息包括IP(互联网协议)地址、浏览器类型、ISP(互联网服务提供商)名称、参考/退出页面、操作系统及日期/时间戳。公司利用这些信息监控未授权访问、进行用户趋势分析、网站管理以及用户在网站上的行为追踪。',
        description2:
          '但是，公司以不能识别特定个人的方式使用这些信息，不会将采集的信息用于上述目的以外的任何目的。'
      },
      webBeacon: {
        title: '网络信标',
        description:
          '公司使用网络信标用于访问分析和附属计划。公司不使用网络信标进行上述目的以外的任何目的或用于识别特定个人。'
      },
      statisticalAnalysis: {
        title: '统计分析',
        description1:
          '公司使用第三方访问分析工具来识别哪些网站和服务受欢迎，并记录用户在LINKTIVITY网站内访问的页面和页面历史。',
        description2:
          '公司使用这些数据为在特定领域表示出兴趣的用户在LINKTIVITY内提供符合其兴趣的内容和广告。',
        description3:
          '公司也可采集不识别个人的统计信息。此外，公司采集的Cookie信息和其他方采集的Cookie信息也可在第三方访问分析工具平台上由双方查看。'
      }
    },
    policy5: {
      title: '匿名处理信息的处理',
      creation: {
        title: '匿名处理信息的创建',
        description1:
          '公司在创建匿名处理信息时采取以下措施。匿名处理信息是指根据法律要求以无法识别特定个人的方式处理个人信息而获得的个人相关信息，使得原个人信息无法恢复。',
        description2:
          '① 按照法律规定的标准进行适当处理 ② 按照法律规定的标准实施安全管理措施以防止删除的信息和处理方法相关信息的泄露 ③ 公开包含在创建的匿名处理信息中的个人相关信息的项目 ④ 不进行识别用于创建匿名处理信息的个人信息所涉原人的行为'
      },
      provision: {
        title: '匿名处理信息的提供',
        description:
          '当向第三方提供匿名处理信息时，公司公开包含在匿名处理信息中的个人相关信息的项目和提供方式，并向接收者明示所提供的信息是匿名处理信息。'
      },
      disclosure: {
        title: '关于匿名处理信息的公开',
        creationSubtitle: '匿名处理信息的创建',
        creationDescription:
          '关于公司持有的以下用户个人信息，公司在采取适当措施防止识别特定个人且确保原个人信息无法恢复的基础上，持续创建匿名处理信息。',
        itemsTitle: '包含在匿名处理信息中的个人相关信息的项目',
        itemsDescription:
          '平台服务提供相关采集的信息：购买日期、参与日期、凭证语言、销售金额范围、参与者数量、预订状态(已确认或已取消)、供应商位置和地区信息、旅行社位置国家。',
        thirdPartyTitle: '匿名处理信息的第三方提供',
        thirdPartyDescription:
          '关于公司创建或持有的匿名处理信息，公司在明示该信息是匿名处理信息的基础上持续向第三方提供。',
        provisionMethod:
          '通过电子通信手段(电子邮件、服务器上传、API集成等)或物理媒体(如DVD)传送密码保护的电子文件。'
      }
    },
    policy6: {
      title: '个人数据的安全管理措施',
      description1:
        '公司采取组织、技术和物理安全管理措施以防止个人数据的泄露、盗用、滥用、未授权访问、篡改和破坏。公司存储个人数据的服务器访问仅限于拥有ID和密码访问权限的授权员工，其中某些个人数据的访问权限仅授予数据管理所必需的最少员工。',
      description2:
        '此外，包含信用卡信息的个人数据存储在分散于多个数据中心的安全环境中。公司对与预订交易相关的所有页面使用安全套接层(SSL)加密。使用SSL兼容浏览器可维护通过互联网传输的个人数据和信用卡信息的机密性。',
      description3:
        '处理用户个人数据的公司员工在离开终端时使用密码保护的屏幕保护程序。',
      description4:
        '此外，公司对某些部门每月进行一次、公司范围内每年至少进行两次关于个人信息重要性等的教育培训。公司还保留这些培训的记录。'
    },
    policy7: {
      title: '关于个人数据处理的用户权利',
      description:
        '根据2016年4月27日的欧盟通用数据保护条例(GDPR) 2016/679，用户在个人数据处理方面具有以下权利：',
      right1: '访问权',
      right2: '更正权',
      right3: '删除权(被遗忘权)和限制处理权',
      right4: '数据可携性权',
      right5: '异议权',
      right6: '不受基于分析的自动化决策约束的权利。'
    },
    policy8: {
      title: '关于公开、更正、中止使用等请求',
      description1:
        '公司通过下文第11节所述的联系方式对用户关于持有个人数据的使用目的通知请求、公开请求、更正/增加/删除请求、使用中止/删除请求以及第三方提供中止请求(以下统称"公开等请求")进行对应。',
      description2:
        '此外，公司通过用户的账户页面对用户更改和确认会员信息以及中止电子邮件杂志配送等的请求进行对应。'
    },
    policy9: {
      title: '关于外部链接',
      description:
        'LINKTIVITY主页包含指向其他网站的链接。本隐私政策仅适用于通过LINKTIVITY主页采集的信息，公司对其他网站的隐私政策或内容不承担责任。用户应阅读所链接网站的隐私政策并确认其个人信息如何被处理。'
    },
    policy10: {
      title: '隐私政策的更改',
      description:
        '公司在LINKTIVITY主页上发布本隐私政策，使用户能够始终了解公司采集什么个人信息、出于什么目的采集以及如何使用。隐私政策的任何更改也会在LINKTIVITY主页上发布并向用户公开。'
    },
    policy11: {
      title: '联系方式',
      description1:
        '关于公司隐私政策、公司个人信息保护措施、采集和使用用户个人信息或提出公开等请求的任何问题，请使用下面的联系表。代表将在5个工作日内回复。',
      company: 'Linktivity Inc.',
      address: '日本东京都千代田区内幸町2-1-6 日比谷公园前19楼',
      dpoContact: '数据保护官联系方式: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '采集的个人信息',
      specificPurpose: '具体的使用目的',
      legalBasis: '法律依据：',
      provisionMethod: '提供方式'
    }
  },
  terms: {
    title: 'LINKTIVITY利用規約',
    lastUpdated: '最終更新日 2020年05月01日',
    intro: {
      company: 'リンクティビティ株式会社（以下、「当社」といいます）は、',
      serviceDesc:
        'のサービスのご利用に関して、以下のとおりLINKTIVITY利用規約（以下、「本規約」といいます）を定めています。',
      agreement:
        'LINKTIVITYをご利用いただいた場合は、本規約に同意したものとみなしますので、LINKTIVITYのサービスをご利用いただきます際には、必ず本規約をお読みください。なお、本規約は、必要に応じ変更することがございますので、ご利用の際には最新の内容をご参照ください。',
      privacyNote: '＊個人情報の取り扱いについては、',
      privacyLinkText: '「個人情報保護方針」',
      privacyNoteSuffix: 'をお読みください。'
    },
    article1: {
      title: '第一条 規約の目的',
      content:
        '本規約は当社が運営する商品・サービス等の場貸し（プラットフォーム）販売サイト「LINKTIVITY」のサービス利用者に適用するものです。本サービスの利用者は、あらかじめ本規約に同意した上で、本サービスを利用するものとします。また、本規約は予告なく変更することがあります。'
    },
    article2: {
      title: '第二条 会員登録',
      items: [
        '「会員」とは、本規約を承認の上、本規約に基づき本サービスの提供を受けるために当社の指定する会員登録手続を完了し、当社が会員として承認した個人とします。ただし、承認後でも、当社が会員として不適当と判断した場合には承認の取り消しを行うことがあります。',
        '会員登録の際の登録情報に関して、いかなる虚偽の申告も認めないものとします。本人、登録情報（氏名、メールアドレス等）、パスワードは、それぞれ一つずつのみ対応するものとし、同一人物による複数の会員としての登録は認めないものとします。',
        '登録情報に変更が生じた場合は、会員は速やかに所定の変更手続きを行うものとします。'
      ]
    },
    article3: {
      title: '第三条 商品提供者が提供する情報',
      content:
        '当社は、LINKTIVITYにおいて、商品提供者が提供する内容、料金、購入可能日時、取消規定（キャンセルポリシー）等購入に必要な情報(以下、「購入関連情報」といいます)、および商品提供者に関する情報を会員に提供しますが、購入関連情報は、商品提供者の責任において提供されるものであり、当社が故意または過失による情報の非伝達のため発生したものを除き、当社は情報の内容については一切責任を負うものではありません。'
    },
    article4: {
      title: '第四条 契約成立',
      content:
        'LINKTIVITYのプラットフォームでは会員が購入する商品、サービス等の提供に関する契約は、会員と商品提供者との間で直接締結されます。LINKTIVITYにおける商品、サービス等の掲載は、商品提供者への申し込みを行うためのものであり、当社はその申し込みを当該商品提供者に代わって自由に承認または却下できます。本利用規約は、会員によるLINKTIVITYサービスの使用を規定するものであり、商品提供者への購入申し込みを行うためにLINKTIVITYを使用する場合も含みます ただし、会員が予約する商品・サービス等の提供は、LINKTIVITYに表示される契約条件、予約手続中に提示される情報、およびプ商品・サービス等の提供に関する法的な契約の締結先である商品提供者が定める契約条件に従うものとします。'
    },
    article5: {
      title: '第五条 代金のお支払',
      content: [
        'LINKTIVITYは商品提供者の代金回収代理業者として、会員のお支払い情報を取得し、支払いを処理します。会員は、商品・サービス等の購入時に当社へクレジットカードまたは当社が提供する決済手段にて代金を支払うものとします。外貨表記ので、当社が日本円でクレジットカード決済額または当社が提供する決済手段の請求金額を決定する場合は、当社が定めるレートにて日本円に換算することとします。',
        '但し、一部については、ページで指定された次のいずれかの方法で支払うものとします。'
      ]
    },
    article6: {
      title: '第六条 商品提供者が提供する商品・サービスの内容・品質',
      content:
        '当社は、商品提供者が提供する商品・サービスの内容・品質については一切責任を負うものではなく、会員と商品提供者との間で生じるトラブル、紛争もしくは苦情、会員が被る損害については、会員が商品提供者との間で解決するものとし、当社はこれらにつき何ら責任を負うものではありません。'
    },
    article7: {
      title: '第七条 利用環境',
      items: [
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の購入に必要な通信機器・ソフトウェア・通信手段等必要なものの全てを用意するものとします。',
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の利用に必要なインターネットに接続可能なスマートフォン・ソフトウェア・通信手段等必要なものの全てを用意するものとします。'
      ]
    },
    article8: {
      title: '第八条 会員の自己都合による購入の取消、取消料',
      items: [
        '会員の自己都合で購入を取消す場合の取消料は、該当商品提供者が定める取消規約（キャンセルポリシー）に則ります。',
        '当社は代金支払時と代金返金時の為替差損益については一切責任を負うものではありません。',
        '購入の取消は、原則、LINKTIVITYのマイページより行うものとします。但し、利用日直前で、商品提供者に直接電話で連絡がとれ、かつ商品提供者が購入の取消を受付けた場合は、後日、マイページよりLINKTIVITYへ、その旨連絡することにより取消手続きは完了するものとします。'
      ]
    },
    article9: {
      title: '第九条 商品提供者による取消、返金',
      content:
        '商品・サービス等の内容変更、中止に伴う会員への告知は商品提供者が行い、当社は商品・サービス等の変更、中止に伴なう責任は一切負いません。ただし、当社は商品提供者の決定・依頼に基づき販売した商品・サービス等の内容の変更や中止による商品・サービス等の払い戻し業務を代行する場合があります。'
    },
    article10: {
      title: '第十条 パスワードの管理',
      items: [
        '会員は、パスワードの管理責任を負うものとします。',
        '会員は、メールアドレス、パスワードを第三者に利用させたり、貸与、譲渡、名義変更、売買、質入等を行うことはできないものとします。',
        '会員のパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任は、会員が負うものとし、当社は一切責任を負いません。'
      ]
    },
    article11: {
      title: '第十一条 会員登録情報の取扱い',
      items: [
        '会員登録の際に会員が登録した個人情報（以下、「登録情報」といいます）は、当社の個人情報保護方針に従い、当社が保有、管理するものとします。',
        {
          text: '当社は、登録情報のうち、特定の個人の識別が可能な情報（以下「個人情報」という。）を、第三者に開示しないものとします。ただし、以下の場合を除きます。',
          subItems: [
            '情報開示についてお客様の同意がある場合',
            '個人情報保護のための守秘義務契約を結んだ業務委託先に対しサービスを履行するために必要な個人情報を提供する場合',
            'サービス向上目的で個人情報を集計および分析し、個人を識別または特定できない状態で第三者に開示または提供する場合',
            '裁判所の発する令状その他裁判所の判断に従い開示する場合'
          ],
          note: 'なお、当社が取得した個人情報に関する、利用目的その他取り扱いについての詳細は「個人情報保護方針」をお読みください。'
        }
      ]
    },
    article12: {
      title: '第十二条 会員の禁止事項',
      intro:
        '会員は、LINKTIVITYを利用する際に、以下の行為またはそのおそれのある行為を行ってはならないものとします。',
      items: [
        '本規約に違反する行為',
        '公序良俗または法令に違反する行為',
        '当社、他の会員または第三者の著作権、肖像権、その他知的所有権を侵害する行為',
        '他の会員または第三者を誹謗・中傷する行為',
        '他の会員または第三者に不利益を与える行為',
        '当社の事業あるいは当社の提供するサービスの運営を妨害する行為',
        '営利を目的とする行為',
        '会員として得た権利を、当社の事前の同意を得ることなく第三者に譲渡および貸与する行為',
        'その他、当社が不適当と判断する行為'
      ]
    },
    article13: {
      title: '第十三条 会員発信情報の削除又は修正',
      intro:
        '当社は、会員が送信した情報のうち、以下のいずれかに該当するまたはそのおそれがあるものを、会員の承諾なく、全部または一部を削除し、またはこれに対し当社が必要と判断する修正を行うことができるものとします。',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当すると当社が判断するもの',
        '事実に明らかに反すると当社が判断するもの',
        'その他当社が不適当と判断するもの'
      ]
    },
    article14: {
      title: '第十四条 会員資格の抹消',
      intro:
        '会員が以下の事由のいずれかに該当する場合、当社は会員に事前の通知することなく、また会員に対して何らの責任を負うことなく、会員資格を抹消することができるものとします',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当する行為を行った場合',
        'その他、本規約のいずれかに違反した場合。',
        'その他、会員として不適格と当社が判断した場合'
      ]
    },
    article15: {
      title: '第十五条 サービスの変更・中断・中止',
      items: [
        '当社は、会員に事前に通知することなく、サービス内容を変更、中断または中止する場合があります。',
        '本サービス内容の変更または中断に伴い、会員に不利益または損害が発生した場合であっても、当社はその責任を負わないものとします。',
        '当社は、会員に対して１ヶ月前に通知することにより、サービスの提供を中止することができるものとします。'
      ]
    },
    article16: {
      title: '第十六条 著作権および財産権',
      content:
        'LINKTIVITYに表示されるすべての内容に関する著作権および財産権は、当社および当社にそれらの内容を提供している、商品提供者、提携先、広告主に帰属しています。利用者および会員は、当社、商品提供者、提携先、広告主の事前の文書による承諾を受けた場合を除いて、それらの内容を複製、公開、譲渡、貸与、翻訳、転載、送信、使用許諾、再利用しないことなどに同意するものとします。また、利用者および会員がこれらの行為によって得た利益相当額を当社が請求できる権利を有していることとします。'
    },
    article17: {
      title: '第十七条 免責・責任制限',
      items: [
        '当社は、会員と商品提供者との間で生じた損害、会員が本規約に違反して生じた損害、商品・サービス等のチケットへの引き換えにおいて当社の責に帰さない事由により発生した損害については、一切の責任を負わないものとします。',
        '商品提供者は、当社とは独立した契約主体であり、商品提供者による、いかなる行為、過失、怠慢、代理行為、保証や、商品・サービス等の参加に関連する会員の負傷、死亡、所有物の損傷・遺失テロリズムに帰する損害、その他あらゆる損害等について、当社は一切責任を負うものではありません。',
        '当社は、当社の直接の管理範囲を超えた原因により生じた、商品・サービス等の遅延、キャンセル、重複購入、ストライキに対する責任を負わないものとします。また、政府当局や裁判所令状等による内容変更、キャンセル、遅延、追加費用の発生等についても応じる義務を負いません。',
        '当社は、当社に故意または過失がある場合においても、会員に対し、本サービスの提供に関連して会員に発生した現実かつ直接の通常損害以外の損害を負担しません。'
      ]
    },
    article18: {
      title: '第十八条 本規約の変更',
      content:
        '本規約の内容について、当社は必要に応じ変更できるものとします。本規約を変更した場合は、本画面上の変更をもってその変更が終了したものとし、都度、会員への通知は行わないものとします。'
    },
    article19: {
      title: '第十九条 合意管轄',
      content:
        '本規約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。'
    },
    article20: {
      title: '第二十条 協議',
      content:
        '本規約に定めのない事項又は本規約に関する疑義が生じた場合には、関係当事者間にて誠意をもって協議し、円満に解決するよう努めるものとします。'
    }
  },
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '服务名称',
    companyName: '销售业者',
    representative: '代表者姓名',
    address: '所在地',
    contact: '咨询处',
    paymentTerms: '付款方式及付款时间',
    deliverySchedule: '商品交付时间',
    sellingPrice: '商品等的销售价格',
    shippingFee: '运费',
    additionalFee: '销售价格・运费等以外的必要费用',
    salesRestrictions: '销售期间・销售数量的限制',
    returnsAndCancellations: '退货・取消',
    otherConditions: '其他条件'
  },
  requireForm: {
    lastName: '姓氏',
    firstName: '名字',
    participantInfo: '用户信息',
    requiredBookingInfo: '所需信息',
    BookingFieldMethod: {
      PER_PARTICIPANT: '每位参加者',
      PER_BOOKING: '每次预订'
    },
    bookingFields: {
      participantEmailAddress: '参加者邮箱',
      hotelName: '住宿地点名称',
      hotelAddress: '住宿地点地址',
      hotelReservationLastName: '住宿代表人 姓',
      hotelReservationFirstName: '住宿代表人 名',
      hotelReservationName: '住宿代表人',
      hotelTel: '住宿地点电话',
      arrivalDate: '到达日',
      arrivalTime: '抵达时间',
      arrivalFlightNumber: '抵达航班号',
      departureDate: '出发日期',
      departureTime: '出发时间',
      departureFlightNumber: '出发航班号',
      destinationEmail: '当地联络方式（邮箱）',
      destinationTel: '当地联络方式（电话）',
      gender: '性别',
      agentChannelRegion: '旅行社所在国家・地区',
      agentChannelLanguage: '旅行社语言',
      participantResidentRegion: '参加者居住国家・地区',
      participantLanguage: '参加者语言',
      passengersQuantity: '乘车人数',
      prescriptionMaskQuantityFree: '带度数面镜所需数量 ※免费',
      prescriptionMaskQuantityPaid: '带度数面镜所需数量 ※现场付费',
      preferredStartTime: '希望的开始时间',
      preferredPickUpLocation: '迎接或乘车地点',
      preferredDropOffLocation: '送返或下车地点',
      participantsQuantity: '参加人数',
      luggageQuantity: '行李箱合计数量',
      childrenWithoutSeatQuantity: '不占座的婴幼儿人数',
      childSeatQuantityPaid: '儿童安全座椅所需数量 ※现场付费',
      childSeatQuantityFree: '儿童安全座椅所需数量 ※免费',
      guideJa: '是否需要日文导游',
      driverJa: '是否需要日文司机',
      guideEn: '是否需要英文导游',
      driverEn: '是否需要英文司机',
      guideZh: '是否需要中文导游',
      driverZh: '是否需要中文司机',
      guideKo: '是否需要韩文导游',
      driverKo: '是否需要韩文司机',
      preferredGuideLanguageCode: '希望的导游服务语言',
      preferredDriverLanguageCode: '希望的司机服务语言',
      passportNationality: '国籍/地区',
      passportFirstName: '参加者名字（请填写与护照相符的英文拼音）',
      passportLastName: '参加者姓氏（请填写与护照相符的英文拼音）',
      dateOfBirth: '出生年月日',
      age: '年龄',
      passportNumber: '护照号码',
      eyesight: '视力',
      weightKg: '体重（kg）',
      heightCm: '身高（cm）',
      shoeSizeCm: '鞋码（cm）',
      weightLbs: '体重（lbs）',
      heightIn: '身高（ft/in）',
      clothesSize: '服装尺寸',
      vegetarianMeals: '是否需要素食',
      divingExperienceTimes: '潜水经验次数',
      rentalEquipmentsFree: '是否需要租借装备 ※免费',
      rentalEquipmentsPayLocally: '是否需要租借装备 ※现场付费',
      male: '男',
      female: '女',
      other: '其他',
      yes: '是',
      no: '否'
    }
  },
  components: {
    selectOption: {
      title: '附加商品',
      quantity: '数量: {{quantity}}',
      addCart: '加入购物车',
      planSelect: '选择方案',
      dateSelect: '选择日期',
      dateLabel: '日期',
      timeSelect: '选择时间',
      quantitySelect: '选择数量',
      quantitySelectLabel: '数量',
      soldOut: '售罄',
      total: '合计',
      viewDetail: '查看详情'
    },
    planDetailDrawer: {
      title: '方案详情',
      planContent: '方案内容',
      meetingPlace: '集合地点',
      cancellationPolicy: '取消政策',
      capacity: '可预订数量',
      maxCapacity: '最大可预订数量',
      minCapacity: '最小可预订数量',
      bookingAcceptance: '可预订期间',
      bookingDeadline: '预订截止日期',
      voucherExpirationPeriod: '凭证有效期',
      inclusion: '包含项目',
      participationLocations: '参加地点',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '集合地点地图',
        NOTE_OF_LOCATION_AND_DIRECTION: '地点及路线说明',
        LANDMARKS_TO_MEETING_POINT: '集合地点地标',
        PICK_UP_CAR: '接送车辆',
        PICK_UP_GUIDE: '接送导游',
        ITINERARY: '行程',
        PARKING: '停车场信息'
      },
      restrictions: '参加限制',
      requirements: '参加前・参加时必要事项',
      attireItems: '参加时必要的服装・物品',
      otherInfo: '备注・其他'
    },
    payment: {
      ticket: '门票',
      option: '附加商品',
      total: '合计（含税）',
      details: '详情',
      submit: '去下单'
    },
    bookInfo: {
      plan: '套餐',
      dateTime: '日期时间',
      validityPeriod: '有效期',
      ticket: '门票',
      option: '附加商品',
      discount: '折扣',
      total: '合计（含税）'
    },
    coupon: {
      title: '优惠券',
      caption: '请输入您的优惠券代码',
      apply: '应用'
    },
    bookingDetailVoucher: {
      pdf: '打印用PDF',
      html: '电子票券'
    },
    collapsibleCard: {
      stockStatus: {
        available: '销售中',
        limited: '剩余少量',
        soldOut: '售罄'
      }
    }
  },
  bookingDetail: {
    title: '预订详情',
    meetingPoint: '入场位置指南',
    beforeTrip: '使用前确认事项',
    reservationInfo: '预订信息',
    redemption: '使用电子票',
    digitalTicketWaiting: '*订单确认后，电子票将在此显示',
    inclusion: '包含的物品',
    restrictions: '参加制限',
    requirements: '参加前・参加时必要事项',
    attireItems: '参加时必要服装・持物',
    otherInfo: '备注・其他',
    cancelSuccess: '已成功取消订单。',
    sendToEmailSuccess: '邮件发送成功，请检查您的收件箱',
    sendToEmailError: '邮件发送失败，请稍后重试'
  },
  bookResult: {
    pendingTitle: '正在确认支付',
    pendingMessage: '您的订单尚未完成，请耐心等待处理完成。',
    successMessage:
      '感谢您的预订。预订凭证将立即发送到您注册的电子邮件地址，请检查您的收件箱。',
    failedMessage: '支付失败，请重新预约。',
    timeoutMessage:
      '处理超时，请稍后再重新整理浏览器，您可查看是否有收到订单通知信或自以下的订单信息画面查看是否有订购成功。',
    backToProduct: '返回商品页'
  },
  booking: {
    title: '预订信息',
    bookingNumber: '预订编号',
    viewDetail: '预订信息查看',
    toBooking: '再次预订',
    bookingRange: {
      oneMonth: '1个月内的预订',
      threeMonths: '3个月内的预订',
      sixMonths: '半年内的预订'
    },
    plan: '方案',
    participationTime: '参加时间',
    validityPeriod: '有效期',
    count: '数量',
    option: '附加商品',
    paidAmount: '支付金额',
    customerName: '预订姓名',
    refundAmount: '退款金额',
    orderCompletionTime: '预订时间',
    adultTicket: '成人',
    childTicket: '儿童',
    status: {
      BOOKING_STATUS_CONFIRMED: '预订成功，已出票',
      BOOKING_STATUS_PENDING: '预约中',
      BOOKING_STATUS_CANCEL_PENDING: '取消中',
      BOOKING_STATUS_CANCELED: '已取消',
      BOOKING_STATUS_USED: '已使用',
      BOOKING_STATUS_WITHDRAWN: '预约未成立',
      BOOKING_STATUS_APPLIED: '抽选申请已受理',
      BOOKING_STATUS_APPLIED_DECLINED: '抽选申请未受理',
      BOOKING_STATUS_DECLINED: '抽选申请未受理'
    }
  }
};
